// extracted by mini-css-extract-plugin
export default {"LiveRegion":"KeyTipsOverlay_LiveRegion__k7DaQ","Badge":"KeyTipsOverlay_Badge__r9-2s","Centered":"KeyTipsOverlay_Centered__CuW3L"};